import React, { useState } from "react";
import CtaSection from "../../components/Common/CtaSection";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";
import ContactMainImg from "../../assets/images/resources/contactus.jpg";

const initialFormState = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const ContactMain = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatusMessage("");
    setStatusType("");

    setIsSending(true);

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const responseText = await response.text();
      let result;

      try {
        result = JSON.parse(responseText);
      } catch {
        throw new Error(
          "The email service is not connected. Please configure the website API on the server."
        );
      }

      if (!response.ok) {
        throw new Error(result.error || "Unable to send your message right now.");
      }

      setStatusType("success");
      setStatusMessage(result.message);
      setFormData(initialFormState);
    } catch (error) {
      setStatusType("error");
      setStatusMessage(
        error?.message ||
        "Something went wrong while sending your message. Please try again in a moment."
      );
    } finally {
      setIsSending(false);
    }
  };

  return (
    <React.Fragment>
      {/*Contact One Start*/}
      <section className="contact-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Contact us</span>
            </div>
            <h2 className="section-title__title">Get in Touch With Us</h2>
          </div>

          <div className="contact-one__inner">
            <center>
              <h1 className="section-section-title__companyname">
                Arch Elevators Private Limited
              </h1>
            </center>
            <br></br>
            <br></br>
            <ul className="contact-one__contact-list list-unstyled">
              <li>
                <div className="icon">
                  <span className="icon-call" />
                </div>
                <div className="content">
                  <h3>Lets Talk us</h3>
                  <p>
                    Phone number:{" "}
                    <a href="tel:+919033226011">+91 90332 26011</a>
                  </p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <span className="icon-location location-icon" />
                </div>
                <div className="content">
                  <h3>Address</h3>
                  <p>
                    A 194, Road no 7,
                    <br /> Gopal Charan Industrial Hub,
                    <br /> Bakrol Bujrang,
                    <br />
                    Gujarat 382433
                  </p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <span className="icon-envolop email-icon" />
                </div>
                <div className="content">
                  <h3>Send us email</h3>
                  <p>
                    <a href="mailto:info@archelevators.com">
                      info@archelevators.com
                    </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/*Contact One End*/}
      {/*Contact Two Start*/}
      <section className="contact-two">
        <div className="container">
          <div className="row">
            <div className="col-xl-7">
              <div className="contact-two__left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Contact</span>
                  </div>
                  <h2 className="section-title__title">Get Touch Here</h2>
                </div>
                <form
                  className="contact-form-validated contact-two__form"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="contact-two__input-box">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          required
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="contact-two__input-box">
                        <input
                          type="email"
                          name="email"
                          placeholder="E-mail"
                          required
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12">
                      <div className="contact-two__input-box">
                        <input
                          type="text"
                          name="subject"
                          placeholder="Subject"
                          required
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="contact-two__input-box text-message-box">
                        <textarea
                          name="message"
                          placeholder="Message"
                          required
                          value={formData.message}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-12">
                      <div className="contact-two__btn-box">
                        <button
                          type="submit"
                          className="thm-btn contact-two__btn"
                          disabled={isSending}
                        >
                          {isSending ? "Sending..." : "Submit Now"}
                          <span />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                {statusMessage ? (
                  <div
                    className={
                      statusType === "success"
                        ? "result text-success"
                        : "result text-danger"
                    }
                  >
                    {statusMessage}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-xl-5">
              <div className="contact-two__right">
                <div className="contact-two__img">
                  <img src={ContactMainImg} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*Contact Two End*/}
      {/*Google Map Start*/}
      <section className="google-map-one google-map-two">
        {/* <iframe src="" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.9817003157564!2d72.7419244!3d22.987700399999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e630045636b1d%3A0xa33820b198ab36ca!2sARCH%20ELEVATORS!5e0!3m2!1sen!2sin!4v1747593788064!5m2!1sen!2sin"
          className="google-map__one"
          allowFullScreen=""
          title="Google Map showing Arch Elevators"
        />
      </section>
      {/*Google Map End*/}

      {/*cta-section */}
      <CtaSection
        breadcrumbsImg={bannerbg}
        shapeImageUrl={shapeImageUrl}
        title="Need any help? contact us!"
        text="Need help?"
        phoneNumber="+91 90332 26011"
      />
      {/*cta-section end */}
    </React.Fragment>
  );
};

export default ContactMain;
